// import React, { useState, useEffect, useRef, useContext } from "react";
// import {
//   ArrowLeftOutlined,
//   DeleteOutlined,
//   PlusOutlined,
//   CloseOutlined,
//   UploadOutlined,
// } from "@ant-design/icons";
// import {
//   Form,
//   Input,
//   Select,
//   DatePicker,
//   Button,
//   message,
//   Row,
//   Card,
//   Col,
//   Modal,
//   Upload,
// } from "antd";
// import {
//   deleteTaskPhoto,
//   getallBoard,
//   getallDeveloperForTask,
//   getallReporterLoginUser,
//   getProjectName,
// } from "../../utils/API";
// import dayjs from "dayjs";
// import { getTaskByID, updateTask } from "../../utils/API";
// import customParseFormat from "dayjs/plugin/customParseFormat";
// import utc from "dayjs/plugin/utc";
// import timezone from "dayjs/plugin/timezone";
// import { UploadChangeParam, UploadFile } from "antd/es/upload";
// import { useDispatch } from "react-redux";
// import { AppDispatch } from "../store";
// import { updateTaskLocal } from "../store/slice/taskSlice";
// import { AuthContext } from "../../Auth/AuthContext";

// // TipTap imports
// import { useEditor, EditorContent } from "@tiptap/react";
// import StarterKit from "@tiptap/starter-kit";
// import Image from "@tiptap/extension-image";
// import Underline from "@tiptap/extension-underline";
// import Link from "@tiptap/extension-link";
// import TextAlign from "@tiptap/extension-text-align";
// import Placeholder from "@tiptap/extension-placeholder";
// import Heading from "@tiptap/extension-heading";
// import BulletList from "@tiptap/extension-bullet-list";

// dayjs.extend(utc);
// dayjs.extend(timezone);
// dayjs.extend(customParseFormat);

// // Custom image extension with size control
// const CustomImage = Image.extend({
//   addAttributes() {
//     return {
//       width: {
//         default: "100px", // Default smaller width
//       },
//       height: {
//         default: "100px",
//       },
//       src: {},
//       alt: {},
//       title: {},
//     };
//   },
// });

// const { Option } = Select;

// interface EditTaskModalProps {
//   visible: boolean;
//   taskId?: string;
//   onCancel?: any;
//   onSuccess?: () => void;
// }

// const EditTaskModal: React.FC<EditTaskModalProps> = (props) => {
//   const [form] = Form.useForm();
//   const IMAGEURL = process.env.REACT_APP_IMAGE_URL + "/task/";
//   const { visible, onCancel, taskId, onSuccess } = props;
//   const [developers, setDevelopers] = useState<
//     { _id: string; username: string }[]
//   >([]);
//   const [reporters, setReporters] = useState<
//     { _id: string; reporterName: string }[]
//   >([]);
//   const [task, setTask] = useState<any>([]);
//   const [isLoading, setIsLoading] = React.useState(false);
//   const [loading, setLoading] = useState(false);
//   const [isStatusDisabled, setIsStatusDisabled] = useState(true);
//   const [boards, setBoards] = useState<{ _id: string; name: string }[]>([]);
//   const [fileList, setFileList] = useState<UploadFile[]>([]);
//   const dispatch = useDispatch<AppDispatch>();
//   const { authData } = useContext(AuthContext);
//   const [descValue, setDescValue] = useState("");
//   const [uploadedImages, setUploadedImages] = useState<File[]>([]);
//   const [ProjectName, setProjectName] = useState<any>([]);
//   const [linkUrl, setLinkUrl] = useState("");
//   const [showLinkInput, setShowLinkInput] = useState(false);
//   const [datePickerOpen, setDatePickerOpen] = useState(false);

//   const isAdmin = authData.roleId?.roleId === 1;

//   // TipTap editor instance with custom image
//   const editor = useEditor({
//     extensions: [
//       StarterKit.configure({
//         heading: false, // disable internal so we add our own
//         bulletList: false,
//         orderedList: false,
//       }),

//       Heading.configure({
//         levels: [1, 2, 3],
//       }),

//       BulletList.configure({
//         keepMarks: true,
//         keepAttributes: false,
//       }),

//       Underline,
//       Link.configure({
//         openOnClick: true,
//         HTMLAttributes: { class: "text-blue-500 underline" },
//       }),

//       Image.extend({
//         addAttributes() {
//           return {
//             src: { default: null },
//             alt: { default: null },
//             title: { default: null },
//             width: {
//               default: 300,
//               renderHTML: (attributes: any) => ({
//                 width: attributes.width,
//                 style: `width: ${attributes.width}px; height: auto; max-width: 100%;`,
//               }),
//             },
//             height: { default: "auto" },
//           };
//         },
//       }).configure({
//         inline: false,
//         HTMLAttributes: {
//           class: "rounded-md",
//           style: "max-width: 100%; height: auto;",
//         },
//       }),

//       TextAlign.configure({
//         types: ["heading", "paragraph"],
//       }),

//       Placeholder.configure({
//         placeholder: "Enter task description2...",
//       }),
//     ],
//     content: "", // will be set later from fetched task data
//     editable: true,
//     onUpdate: ({ editor }) => {
//       const html = editor.getHTML();
//       setDescValue(html);
//       form.setFieldsValue({ taskDesc: html });
//     },
//     editorProps: {
//       handlePaste: (view, event) => {
//         const items = Array.from(event.clipboardData?.items || []);
//         let imageProcessed = false;

//         for (const item of items) {
//           if (item.type.startsWith("image/")) {
//             event.preventDefault();
//             const file = item.getAsFile();
//             if (!file) continue;

//             // Add to uploaded images for form submission
//             setUploadedImages((prev) => [...prev, file]);

//             // Convert to base64 and insert into editor with reduced size
//             const reader = new FileReader();
//             reader.onload = () => {
//               const transaction = view.state.tr.insert(
//                 view.state.selection.from,
//                 view.state.schema.nodes.image.create({
//                   src: reader.result,
//                   alt: "Pasted image",
//                   title: "Pasted image",
//                   width: 300,
//                 })
//               );
//               view.dispatch(transaction);
//             };
//             reader.readAsDataURL(file);
//             imageProcessed = true;
//             break;
//           }
//         }
//         return imageProcessed;
//       },
//       handleDrop: (view, event, slice, moved) => {
//         if (event.dataTransfer?.files) {
//           const files = Array.from(event.dataTransfer.files);
//           let imageProcessed = false;

//           files.forEach((file) => {
//             if (file.type.startsWith("image/")) {
//               event.preventDefault();
//               imageProcessed = true;

//               // Add to uploaded images for form submission
//               setUploadedImages((prev) => [...prev, file]);

//               // Convert to base64 and insert into editor with reduced size
//               const reader = new FileReader();
//               reader.onload = () => {
//                 const coordinates = view.posAtCoords({
//                   left: event.clientX,
//                   top: event.clientY,
//                 });

//                 if (coordinates) {
//                   const transaction = view.state.tr.insert(
//                     coordinates.pos,
//                     view.state.schema.nodes.image.create({
//                       src: reader.result,
//                       alt: file.name,
//                       title: file.name,
//                       width: 300,
//                     })
//                   );
//                   view.dispatch(transaction);
//                 }
//               };
//               reader.readAsDataURL(file);
//             }
//           });

//           return imageProcessed;
//         }
//         return false;
//       },
//     },
//   });

//   // Add these toolbar functions after the editor configuration
//   const setLink = () => {
//     if (linkUrl) {
//       editor?.chain().focus().setLink({ href: linkUrl }).run();
//       setLinkUrl("");
//       setShowLinkInput(false);
//     }
//   };

//   const unsetLink = () => {
//     editor?.chain().focus().unsetLink().run();
//     setShowLinkInput(false);
//   };

//   // Add the Toolbar component after the toolbar functions
//   const Toolbar = () => {
//     if (!editor) return null;

//     return (
//       <div className="border-b border-gray-200 p-2 flex flex-wrap items-center gap-1 bg-gray-50">
//         {/* Text formatting */}
//         <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
//           <Button
//             type={editor.isActive("bold") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().toggleBold().run()}
//             title="Bold"
//           >
//             <strong>B</strong>
//           </Button>
//           <Button
//             type={editor.isActive("italic") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().toggleItalic().run()}
//             title="Italic"
//           >
//             <em>I</em>
//           </Button>
//           <Button
//             type={editor.isActive("underline") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().toggleUnderline().run()}
//             title="Underline"
//           >
//             <u>U</u>
//           </Button>
//           <Button
//             type={editor.isActive("strike") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().toggleStrike().run()}
//             title="Strikethrough"
//           >
//             <s>S</s>
//           </Button>
//         </div>

//         {/* Headings */}
//         <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
//           <Button
//             type={
//               editor.isActive("heading", { level: 1 }) ? "primary" : "default"
//             }
//             size="small"
//             onClick={() =>
//               editor.chain().focus().toggleHeading({ level: 1 }).run()
//             }
//             title="Heading 1"
//           >
//             H1
//           </Button>
//           <Button
//             type={
//               editor.isActive("heading", { level: 2 }) ? "primary" : "default"
//             }
//             size="small"
//             onClick={() =>
//               editor.chain().focus().toggleHeading({ level: 2 }).run()
//             }
//             title="Heading 2"
//           >
//             H2
//           </Button>
//           <Button
//             type={
//               editor.isActive("heading", { level: 3 }) ? "primary" : "default"
//             }
//             size="small"
//             onClick={() =>
//               editor.chain().focus().toggleHeading({ level: 3 }).run()
//             }
//             title="Heading 3"
//           >
//             H3
//           </Button>
//           <Button
//             type={editor.isActive("paragraph") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().setParagraph().run()}
//             title="Paragraph"
//           >
//             P
//           </Button>
//         </div>

//         {/* Lists */}
//         <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
//           <Button
//             type={editor.isActive("bulletList") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().toggleBulletList().run()}
//             title="Bullet List"
//           >
//             • List
//           </Button>
//           <Button
//             type={editor.isActive("orderedList") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().toggleOrderedList().run()}
//             title="Numbered List"
//           >
//             1. List
//           </Button>
//           <Button
//             type={editor.isActive("blockquote") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().toggleBlockquote().run()}
//             title="Blockquote"
//           >
//             ❝
//           </Button>
//         </div>

//         {/* Alignment */}
//         <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
//           <Button
//             type={
//               editor.isActive({ textAlign: "left" }) ? "primary" : "default"
//             }
//             size="small"
//             onClick={() => editor.chain().focus().setTextAlign("left").run()}
//             title="Align Left"
//           >
//             ⬅
//           </Button>
//           <Button
//             type={
//               editor.isActive({ textAlign: "center" }) ? "primary" : "default"
//             }
//             size="small"
//             onClick={() => editor.chain().focus().setTextAlign("center").run()}
//             title="Align Center"
//           >
//             ↔
//           </Button>
//           <Button
//             type={
//               editor.isActive({ textAlign: "right" }) ? "primary" : "default"
//             }
//             size="small"
//             onClick={() => editor.chain().focus().setTextAlign("right").run()}
//             title="Align Right"
//           >
//             ➡
//           </Button>
//         </div>

//         {/* Links */}
//         <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
//           {showLinkInput ? (
//             <div className="flex items-center gap-1">
//               <Input
//                 size="small"
//                 placeholder="Enter URL"
//                 value={linkUrl}
//                 onChange={(e) => setLinkUrl(e.target.value)}
//                 style={{ width: 150 }}
//               />
//               <Button size="small" type="primary" onClick={setLink}>
//                 Add
//               </Button>
//               <Button size="small" onClick={unsetLink}>
//                 Remove
//               </Button>
//             </div>
//           ) : (
//             <Button
//               type={editor.isActive("link") ? "primary" : "default"}
//               size="small"
//               onClick={() => setShowLinkInput(true)}
//               title="Add Link"
//             >
//               🔗
//             </Button>
//           )}
//         </div>

//         {/* Media */}
//         <div className="flex items-center gap-1">
//           <Button
//             size="small"
//             onClick={addImage}
//             title="Insert Image"
//             icon={<UploadOutlined />}
//           >
//             Image
//           </Button>
//         </div>

//         {/* Clear formatting */}
//         <div className="flex items-center gap-1 border-l border-gray-300 pl-2">
//           <Button
//             size="small"
//             onClick={() =>
//               editor.chain().focus().clearNodes().unsetAllMarks().run()
//             }
//             title="Clear Formatting"
//           >
//             Clear
//           </Button>
//           <Button
//             size="small"
//             onClick={() => editor.chain().focus().undo().run()}
//             title="Undo"
//           >
//             ↶
//           </Button>
//           <Button
//             size="small"
//             onClick={() => editor.chain().focus().redo().run()}
//             title="Redo"
//           >
//             ↷
//           </Button>
//         </div>
//       </div>
//     );
//   };

//   const addImage = () => {
//     const input = document.createElement("input");
//     input.type = "file";
//     input.accept = "image/*";
//     input.multiple = true;
//     input.click();

//     input.onchange = () => {
//       const files = Array.from(input.files || []);
//       const imageFiles = files.filter((file) => file.type.startsWith("image/"));

//       // Add all images to uploaded images at once
//       setUploadedImages((prev) => [...prev, ...imageFiles]);

//       // Insert images one by one with reduced size
//       imageFiles.forEach((file) => {
//         const reader = new FileReader();
//         reader.onload = () => {
//           editor
//             ?.chain()
//             .focus()
//             .setImage({
//               src: reader.result as string,
//               alt: file.name,
//               title: file.name,
//               width: 300,
//             })
//             .run();
//         };
//         reader.readAsDataURL(file);
//       });
//     };
//   };

//   const clearDescription = () => {
//     editor?.commands.setContent("");
//     setUploadedImages([]);
//     setFileList([]);
//     form.setFieldsValue({ taskDesc: "" });
//   };
// const handleDeadlineDateChange = (date: dayjs.Dayjs | null) => {
//     try {
//       // Update form value immediately
//       form.setFieldValue('deadlineDate', date);

//       // Optional: Show feedback to user
//       // if (date) {
//       //   message.success(`Deadline updated to: ${date.format('DD-MM-YYYY HH:mm')}`, 2);
//       // }

//       // Auto-close the picker after a short delay
//       setTimeout(() => {
//         setDatePickerOpen(false);
//       }, 300);
//     } catch (error) {
//       console.error('Error setting deadline date:', error);
//     }
//   };
//   useEffect(() => {
//     const fetchBoards = async () => {
//       const response = await getallBoard("", 1);
//       setBoards(response.data);
//     };
//     fetchBoards();
//   }, []);

//   useEffect(() => {
//     const fetchDevelopers = async () => {
//       try {
//         setLoading(true);
//         const response: any = await getallDeveloperForTask("", "");
//         if (response?.data) {
//           setDevelopers(response.data);
//         } else {
//           setDevelopers([]);
//         }
//       } catch (error) {
//         console.error("Error fetching developers:", error);
//         message.error("Failed to load developers");
//         setDevelopers([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     const fetchReporters = async () => {
//       try {
//         const response: any = await getallReporterLoginUser("");
//         if (response) {
//           setReporters(response?.data);
//         } else {
//           setReporters([]);
//         }
//       } catch (error) {
//         console.error("Error fetching reporters:", error);
//         message.error("Failed to load reporters");
//         setReporters([]);
//       }
//     };

//     const fetchProjectNames = async () => {
//       try {
//         const response: any = await getProjectName();

//         // 🧠 Get full user auth data from localStorage
//         const authData = JSON.parse(localStorage.getItem("authData") || "{}");
//         const user = authData?.user;
//         const role = authData?.roleId;

//         const userId = user?._id;
//         const roleSlug = role?.slug?.toLowerCase(); // e.g., "team", "admin", etc.

//         let filteredProjects = response.data;

//         // ✅ Apply filter only for developers/team role
//         if (roleSlug === "team" || roleSlug === "developers") {
//           filteredProjects = response.data.filter(
//             (project: any) =>
//               Array.isArray(project.assignees) &&
//               project.assignees.some(
//                 (assignee: any) =>
//                   assignee === userId || assignee?._id === userId
//               )
//           );
//         }

//         setProjectName(filteredProjects);
//       } catch (error) {
//         console.error("Error fetching project names:", error);
//         message.error("Failed to load projects");
//         setProjectName([]);
//       }
//     };
//     fetchProjectNames();

//     fetchDevelopers();
//     fetchReporters();
//   }, []);

//   const fetchTask = async () => {
//     if (!taskId) return;
//     setLoading(true);

//     try {
//       const data = await getTaskByID(taskId);
//       setTask(data);

//       if (data) {
//         form.setFieldsValue({
//           userId: data.userId?._id,
//           boardId: data.boardId,
//           taskName: data.taskName,
//           startDate: data.startDate ? dayjs(data.startDate) : null,
//           deadlineDate: data.deadlineDate ? dayjs(data.deadlineDate) : null,
//           status: data.status,
//           priority: data.priority,
//           assignees: data.assignees?.map((a: any) => a._id),
//           reporterId: data.reporter?._id,
//           isActive: true,
//           taskDesc: data.taskDesc || "",
//           subTasks:
//             data.subTasks?.map((s: any) => ({
//               subTaskName: s.subTaskName,
//               subTaskDesc: s.subTaskDesc,
//               status: s.status,
//               assignees: s.assignees?.map((a: any) => a._id) || [],
//               isActive: true,
//             })) || [],
//         });

//         // ✅ Prepare editor content
//         let editorContent = data.taskDesc || "";

//         // ✅ Normalize photos (handle both array and single string)
//         const photos = Array.isArray(data.photo)
//           ? data.photo
//           : data.photo
//           ? [data.photo]
//           : [];

//         // ✅ Append all photos at the top of editor content
//         if (photos.length > 0) {
//           const imageHTML = photos
//             .map(
//               (img: any) =>
//                 `<p><img src="${IMAGEURL}${img}" width="200px" /></p>`
//             )
//             .join("");
//           editorContent = `${imageHTML}${editorContent}`;
//         }

//         // ✅ Set TipTap editor content
//         if (editor) {
//           editor.commands.setContent(editorContent);
//         }

//         // ✅ Show image previews in Upload
//         if (photos.length > 0) {
//           setFileList(
//             photos.map((img: string, index: number) => ({
//               uid: `existing-${index}`,
//               name: img.split("/").pop() || `photo-${index}`,
//               status: "done",
//               url: `${IMAGEURL}${img}`,
//             }))
//           );
//         } else {
//           setFileList([]);
//         }
//       }
//     } catch (error) {
//       message.error("Failed to fetch task data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (visible && taskId) {
//       fetchTask();
//     } else {
//       form.resetFields();
//       setDescValue("");
//       setUploadedImages([]);
//       setFileList([]);
//       editor?.commands.setContent("");
//       setDatePickerOpen(false);
//     }
//   }, [visible, taskId]);

//   const handleSubmit = async (values: any) => {
//     try {
//       setLoading(true);

//       const formData = new FormData();

//       // ✅ Append normal fields
//       const simpleFields = [
//         "userId",
//         "boardId",
//         "taskName",
//         "status",
//         "priority",
//         "reporterId",
//       ];
//       simpleFields.forEach((field) => {
//         if (values[field] !== undefined && values[field] !== null) {
//           formData.append(field, values[field]);
//         }
//       });

//       // ✅ Get HTML content from editor instead of plain text
//       const htmlContent = editor?.getHTML() || "";

//       // ✅ Validate that there's actual content (not just empty HTML tags)
//       const hasContent = htmlContent.replace(/<[^>]*>/g, "").trim().length > 0;

//       if (!hasContent && fileList.length === 0) {
//         message.error("Please enter a task description or upload an image");
//         setLoading(false);
//         return;
//       }

//       // ✅ Append the HTML content to formData
//       formData.append("taskDesc", htmlContent);

//       // ✅ Rest of your existing code for file handling...
//       const newFiles = fileList.filter(
//         (file) => file.originFileObj instanceof File
//       );
//       const remainingPhotos = fileList
//         .filter((file) => !file.originFileObj && file.url)
//         .map((file) => {
//           return file.url ? file.url.replace(IMAGEURL, "") : "";
//         })
//         .filter((name) => !!name);

//       formData.append("remainingPhotos", JSON.stringify(remainingPhotos));

//       newFiles.forEach((file) => {
//         formData.append("photo", file.originFileObj as File);
//       });

//       if (fileList.length === 0) {
//         formData.append("removePhoto", "true");
//       }

//       // ✅ Handle Dates
//       if (values.startDate)
//         formData.append("startDate", values.startDate.format());
//       if (values.deadlineDate)
//         formData.append("deadlineDate", values.deadlineDate.format());

//       // ✅ Handle Assignees
//       (values.assignees || []).forEach((id: string) => {
//         formData.append("assignees[]", id);
//       });

//       // ✅ Handle SubTasks
//       (values.subTasks || []).forEach((subtask: any, index: number) => {
//         formData.append(`subTasks[${index}][subTaskName]`, subtask.subTaskName);
//         formData.append(`subTasks[${index}][subTaskDesc]`, subtask.subTaskDesc);
//         formData.append(`subTasks[${index}][status]`, subtask.status);
//         (subtask.assignees || []).forEach((a: string, i: number) => {
//           formData.append(`subTasks[${index}][assignees][${i}]`, a);
//         });
//         formData.append(`subTasks[${index}][isActive]`, "true");
//       });

//       // ✅ API call
//       const response = await updateTask(taskId as string, formData);

//       if (response && (response.status === 200 || response.status === 201)) {
//         message.success("Task updated successfully!");
//         const updatedTask = response.data?.data || response.data;
//         dispatch(
//           updateTaskLocal({ taskId: taskId as string, updates: updatedTask })
//         );

//         setFileList([]);
//         if (onSuccess) onSuccess();
//       } else {
//         message.error(response?.data?.message || "Failed to update task");
//       }
//     } catch (error: any) {
//       message.error(
//         "Task update failed: " +
//           (error.response?.data?.message || "Server error")
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!editor) return;

//     const handleDrop = (event: DragEvent) => {
//       event.preventDefault();

//       const files = Array.from(event.dataTransfer?.files || []);
//       files.forEach((file) => {
//         if (!file.type.startsWith("image/")) return;

//         const reader = new FileReader();
//         reader.onload = () => {
//           //@ts-ignore
//           editor
//             .chain()
//             .focus()
//             .setImage({ src: reader.result as string, width: 200 })
//             .run();
//           setUploadedImages((prev) => [...prev, file]);
//           setFileList((prev) => [
//             ...prev,
//             {
//               uid: `new-${Date.now()}`,
//               name: file.name,
//               status: "done",
//               url: URL.createObjectURL(file),
//             } as UploadFile,
//           ]);
//         };
//         reader.readAsDataURL(file);
//       });
//     };

//     const handlePaste = (event: ClipboardEvent) => {
//       const items = Array.from(event.clipboardData?.items || []);
//       items.forEach((item) => {
//         if (item.type.indexOf("image") === -1) return;
//         const file = item.getAsFile();
//         if (!file) return;

//         const reader = new FileReader();
//         reader.onload = () => {
//           //@ts-ignore
//           editor
//             .chain()
//             .focus()
//             .setImage({ src: reader.result as string, width: 200 })
//             .run();
//           setUploadedImages((prev) => [...prev, file]);
//           setFileList((prev) => [
//             ...prev,
//             {
//               uid: `new-${Date.now()}`,
//               name: file.name,
//               status: "done",
//               url: URL.createObjectURL(file),
//             },
//           ]);
//         };
//         reader.readAsDataURL(file);
//       });
//     };

//     const editorElement = editor.view.dom;
//     editorElement.addEventListener("drop", handleDrop);
//     editorElement.addEventListener("paste", handlePaste);

//     return () => {
//       editorElement.removeEventListener("drop", handleDrop);
//       editorElement.removeEventListener("paste", handlePaste);
//     };
//   }, [editor]);

//   const handleFormChange = (_: any, allValues: any) => {
//     const { startDate, deadlineDate } = allValues;
//     if (startDate && deadlineDate) {
//       setIsStatusDisabled(false);
//     } else {
//       setIsStatusDisabled(true);
//     }
//   };

//   const handleDeletePhoto = async () => {
//     try {
//       setLoading(true);
//       const response = await deleteTaskPhoto(taskId as string);
//       if (response && (response.status === 200 || response.status === 201)) {
//         message.success("Photo deleted successfully!");
//         setFileList([]);
//         setTask((prev: any) => ({ ...prev, photo: null }));
//         // Clear the image from the editor
//         editor?.commands.setContent(editor.getText().trim());
//       } else {
//         message.error(response?.data?.message || "Failed to delete photo");
//       }
//     } catch (error: any) {
//       message.error(
//         "Photo deletion failed: " +
//           (error.response?.data?.message || "Server error")
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Modal
//       open={visible}
//       onCancel={onCancel}
//       footer={null}
//       width={700}
//       centered
//       className="custom-modal"
//       bodyStyle={{
//         overflowY: "auto",
//         fontFamily: "inter, sans-serif",
//       }}
//       styles={{
//         header: {
//           padding: "12px",
//           position: "sticky",
//           top: 0,
//           backgroundColor: "#f1f5ffff",
//         },
//         content: {
//           padding: 0,
//           overflow: "hidden",
//         },
//       }}
//       title={
//         <div
//           style={{
//             color: "#4b5563",
//             fontFamily: "inter, sans-serif",
//             fontSize: "20px",
//             fontWeight: 500,
//           }}
//         >
//           Edit Task
//         </div>
//       }
//     >
//       <Form
//         onFinish={handleSubmit}
//         form={form}
//         layout="horizontal"
//         labelCol={{ span: 4 }}
//         wrapperCol={{ span: 19 }}
//         colon={false}
//         onValuesChange={handleFormChange}
//       >
//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563",
//                 fontFamily: "inter, sans-serif",
//                 fontSize: "14px",
//                 fontWeight: 500,
//                 paddingLeft: "15px",
//               }}
//             >
//               Board<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           name="boardId"
//           rules={[{ required: true, message: "Please select a board" }]}
//         >
//           <Select placeholder="Select Board" disabled={!isAdmin}>
//             {boards.map((board: any) => (
//               <Option key={board._id} value={board._id}>
//                 {board.name}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         {/* <Form.Item
//           label={<span style={{
//             color: '#4b5563',
//             fontFamily: 'inter, sans-serif',
//             fontSize: '14px',
//             fontWeight: 500,
//             paddingLeft: "15px",
//           }}>Task Name<span className="text-red-500">*</span></span>}
//           required={false}
//           name="taskName"
//           rules={[{ required: true, message: "Please enter task name" }]}
//         >
//           <Input placeholder="Enter task name" className="Allinput" />
//         </Form.Item> */}

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563",
//                 fontFamily: "inter, sans-serif",
//                 fontSize: "14px",
//                 fontWeight: 500,
//                 paddingLeft: "15px",
//               }}
//             >
//               Task Name<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           name="taskName"
//           rules={[{ required: true, message: "Please enter task name" }]}
//         >
//           <Select placeholder="Select Project" showSearch>
//             {ProjectName.map((p: any) => (
//               <Option key={p._id} value={p.projectName}>
//                 {p.projectName}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563",
//                 fontFamily: "inter, sans-serif",
//                 fontSize: "14px",
//                 fontWeight: 500,
//                 paddingLeft: "15px",
//               }}
//             >
//               Description<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           rules={[{ required: true, message: "Please enter description" }]}
//         >
//           <div className="border rounded bg-white">
//             <Toolbar />
//             <div className="p-3 min-h-[150px]">
//               <EditorContent
//                 editor={editor}
//                 className="min-h-[100px] outline-none"
//               />
//             </div>
//           </div>
//         </Form.Item>

//         <Form.Item name="taskDesc" hidden>
//           <Input type="hidden" />
//         </Form.Item>

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563",
//                 fontFamily: "inter, sans-serif",
//                 fontSize: "14px",
//                 fontWeight: 500,
//                 paddingLeft: "15px",
//               }}
//             >
//               Deadline Date<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           name="deadlineDate"
//           rules={[{ required: true, message: "Please select deadline" }]}
//         >
//          <DatePicker
//                      showTime
//                      format="DD-MM-YYYY HH:mm"
//                      className="w-full"
//                      open={datePickerOpen}
//                      onOpenChange={(open) => {
//                        setDatePickerOpen(open);
//                        // When closing without selection, ensure we have the current value
//                        if (!open) {
//                          const currentValue = form.getFieldValue('deadlineDate');
//                          if (currentValue) {
//                            handleDeadlineDateChange(currentValue);
//                          }
//                        }
//                      }}
//                      onChange={(date) => {
//                        // Auto-save when date changes (including time changes)
//                        handleDeadlineDateChange(date);
//                      }}
//                      //@ts-ignore
//                      onSelect={(date) => {
//                        // Immediate save when selecting from calendar
//                        handleDeadlineDateChange(date);
//                      }}
//                      onOk={() => {
//                        // Empty function - we don't need OK button
//                      }}
//                      // Remove the need for confirmation
//                      needConfirm={false}
//                      disabledDate={(current) => {
//                        return current && current < dayjs().startOf('day');
//                      }}
//                      showNow={true}
//                      // Optional: Auto-close when time is selected
//                      onPanelChange={(value, mode) => {
//                        if (mode === 'time') {
//                          // When switching to time panel, you might want different behavior
//                        }
//                      }}
//                    />
//                  </Form.Item>

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563",
//                 fontFamily: "inter, sans-serif",
//                 fontSize: "14px",
//                 fontWeight: 500,
//                 paddingLeft: "15px",
//               }}
//             >
//               Priority<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           name="priority"
//           rules={[{ required: true, message: "Please select priority" }]}
//         >
//           <Select placeholder="Select Priority">
//             <Option value="Low">Low</Option>
//             <Option value="Medium">Medium</Option>
//             <Option value="High">High</Option>
//           </Select>
//         </Form.Item>

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563",
//                 fontFamily: "inter, sans-serif",
//                 fontSize: "14px",
//                 fontWeight: 500,
//                 paddingLeft: "15px",
//               }}
//             >
//               Assignees<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           name="assignees"
//           rules={[
//             { required: true, message: "Please select at least one assignee" },
//           ]}
//         >
//           <Select
//             mode="multiple"
//             placeholder="Select Assignees"
//             filterOption={(input, option) =>
//               (option?.children ?? "")
//                 .toString()
//                 .toLowerCase()
//                 .includes(input.toLowerCase())
//             }
//           >
//             {developers.map((dev) => (
//               <Option key={dev._id} value={dev._id}>
//                 {dev.username}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563",
//                 fontFamily: "inter, sans-serif",
//                 fontSize: "14px",
//                 fontWeight: 500,
//                 paddingLeft: "15px",
//               }}
//             >
//               Reporter<span className="text-red-500"></span>
//             </span>
//           }
//           required={false}
//           name="reporterId"
//         >
//           <Select placeholder="Select Reporter">
//             {reporters.map((r) => (
//               <Option key={r._id} value={r._id}>
//                 {r.reporterName}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563",
//                 fontFamily: "inter, sans-serif",
//                 fontSize: "14px",
//                 fontWeight: 500,
//                 paddingLeft: "15px",
//               }}
//             >
//               SubTasks<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           wrapperCol={{ span: 18 }}
//         >
//           <Form.List name="subTasks">
//             {(fields, { add, remove }) => (
//               <div>
//                 <Button
//                   type="dashed"
//                   icon={<PlusOutlined />}
//                   className="mb-3"
//                   onClick={() => add()}
//                 >
//                   Add Subtask
//                 </Button>
//                 {fields.map(({ key, name, ...restField }) => (
//                   <div
//                     key={key}
//                     className="border rounded p-3 mb-3 bg-white shadow-sm"
//                   >
//                     <div className="grid grid-cols-2 gap-3">
//                       <Form.Item {...restField} name={[name, "subTaskName"]}>
//                         <Input
//                           placeholder="Subtask name"
//                           className="Allinput"
//                         />
//                       </Form.Item>
//                       <Form.Item {...restField} name={[name, "subTaskDesc"]}>
//                         <Input placeholder="Description" className="Allinput" />
//                       </Form.Item>
//                       <Form.Item {...restField} name={[name, "status"]}>
//                         <Select placeholder="Status">
//                           <Option value="Pending">Pending</Option>
//                           <Option value="In Progress">In Progress</Option>
//                           <Option value="Completed">Completed</Option>
//                         </Select>
//                       </Form.Item>
//                       <Form.Item {...restField} name={[name, "assignees"]}>
//                         <Select mode="multiple" placeholder="Assignees">
//                           {developers.map((dev) => (
//                             <Option key={dev._id} value={dev._id}>
//                               {dev.username}
//                             </Option>
//                           ))}
//                         </Select>
//                       </Form.Item>
//                     </div>
//                     <Button danger type="text" onClick={() => remove(name)}>
//                       Remove
//                     </Button>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </Form.List>
//         </Form.Item>

//         {/* {fileList.length > 0 && (
//           <Form.Item
//             label={<span style={{
//               color: '#4b5563',
//               fontFamily: 'inter, sans-serif',
//               fontSize: '14px',
//               fontWeight: 500,
//             }}>Photo</span>}
//             wrapperCol={{ span: 19 }}
//           >
//             <Upload
//               fileList={fileList}
//               listType="picture"
//               showUploadList={{ showRemoveIcon: true }}
//               onRemove={handleDeletePhoto}
//             />
//           </Form.Item>
//         )} */}

//         <div className="flex justify-end gap-3 pr-5">
//           <button
//             type="button"
//             className="allcanclebutton"
//             onClick={onCancel}
//             disabled={isLoading}
//           >
//             Cancel
//           </button>
//           <button className="allsubmitebutton" type="submit">
//             {isLoading ? "Updating..." : "Update"}
//           </button>
//         </div>
//       </Form>
//     </Modal>
//   );
// };

// export default EditTaskModal;

import React, { useState, useEffect, useRef, useContext } from "react";
import {
  ArrowLeftOutlined,
  DeleteOutlined,
  PlusOutlined,
  CloseOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  message,
  Row,
  Card,
  Col,
  Modal,
  Upload,
  Switch,
} from "antd";
import {
  deleteTaskPhoto,
  getallBoard,
  getallDeveloperForTask,
  getallReporterLoginUser,
  getProjectName,
} from "../../utils/API";
import dayjs from "dayjs";
import { getTaskByID, updateTask } from "../../utils/API";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { UploadChangeParam, UploadFile } from "antd/es/upload";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../store";
import { updateTaskLocal } from "../store/slice/taskSlice";
import { AuthContext } from "../../Auth/AuthContext";

// TipTap imports
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Image from "@tiptap/extension-image";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import Placeholder from "@tiptap/extension-placeholder";
import Heading from "@tiptap/extension-heading";
import BulletList from "@tiptap/extension-bullet-list";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

// Custom image extension with size control
const CustomImage = Image.extend({
  addAttributes() {
    return {
      width: {
        default: "100px", // Default smaller width
      },
      height: {
        default: "100px",
      },
      src: {},
      alt: {},
      title: {},
    };
  },
});

const { Option } = Select;

interface EditTaskModalProps {
  visible: boolean;
  taskId?: string;
  onCancel?: any;
  onSuccess?: () => void;
}

const EditTaskModal: React.FC<EditTaskModalProps> = (props) => {
  const [form] = Form.useForm();
  const IMAGEURL = process.env.REACT_APP_IMAGE_URL + "/task/";
  const { visible, onCancel, taskId, onSuccess } = props;
  const [developers, setDevelopers] = useState<
    { _id: string; username: string }[]
  >([]);
  const [reporters, setReporters] = useState<
    { _id: string; reporterName: string }[]
  >([]);
  const [task, setTask] = useState<any>([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [isStatusDisabled, setIsStatusDisabled] = useState(true);
  const [boards, setBoards] = useState<{ _id: string; name: string }[]>([]);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const dispatch = useDispatch<AppDispatch>();
  const { authData } = useContext(AuthContext);
  const [descValue, setDescValue] = useState("");
  const [uploadedImages, setUploadedImages] = useState<File[]>([]);
  const [ProjectName, setProjectName] = useState<any>([]);
  const [linkUrl, setLinkUrl] = useState("");
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [notificationEnabled, setNotificationEnabled] = useState(false); // State for notification switch
  const editorContainerRef = useRef<HTMLDivElement | null>(null);
  const [selectedImageDeleteIcon, setSelectedImageDeleteIcon] = useState<{
    visible: boolean;
    top: number;
    left: number;
    pos: number | null;
  }>({
    visible: false,
    top: 0,
    left: 0,
    pos: null,
  });

  const isAdmin = authData.roleId?.roleId === 1;

  useEffect(() => {
    if (!visible) {
      setSelectedImageDeleteIcon({
        visible: false,
        top: 0,
        left: 0,
        pos: null,
      });
    }
  }, [visible]);

  const normalizeTaskPhotos = (photo: any): string[] => {
    if (Array.isArray(photo)) {
      return photo.filter(Boolean);
    }

    return photo ? [photo] : [];
  };

  const getTaskPhotoNameFromSrc = (src: string) => {
    if (!src || src.startsWith("data:")) {
      return "";
    }

    const cleanSrc = src.split("?")[0].split("#")[0];
    const imageBase = IMAGEURL.replace(/\/$/, "");
    const normalizedSrc = cleanSrc.replace(/\\/g, "/");
    let photoName = "";

    if (normalizedSrc.startsWith(imageBase)) {
      photoName = normalizedSrc.slice(imageBase.length).replace(/^\/+/, "");
    } else {
      const taskPathIndex = normalizedSrc.lastIndexOf("/task/");
      photoName =
        taskPathIndex >= 0 ? normalizedSrc.slice(taskPathIndex + 6) : "";
    }

    try {
      return decodeURIComponent(photoName);
    } catch {
      return photoName;
    }
  };

  const getTaskPhotoUrl = (photoName: string) =>
    `${IMAGEURL}${encodeURIComponent(photoName)}`;

  const getTaskPhotoNamesFromHtml = (html: string) => {
    const container = document.createElement("div");
    container.innerHTML = html;

    return Array.from(container.querySelectorAll("img"))
      .map((img) => getTaskPhotoNameFromSrc(img.getAttribute("src") || ""))
      .filter(Boolean);
  };

  const removeTemporaryImagesFromHtml = (html: string) => {
    const container = document.createElement("div");
    container.innerHTML = html;

    container.querySelectorAll("img").forEach((img) => {
      const src = img.getAttribute("src") || "";

      if (src.startsWith("data:") || src.startsWith("blob:")) {
        img.remove();
      }
    });

    return container.innerHTML;
  };

  const showImageDeleteIcon = (imageNode: HTMLElement, pos: number | null) => {
    const container = editorContainerRef.current;

    if (!container || !(imageNode instanceof HTMLElement)) {
      setSelectedImageDeleteIcon({ visible: true, top: 8, left: 8, pos });
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const imageRect = imageNode.getBoundingClientRect();
    const left = Math.min(
      Math.max(imageRect.right - containerRect.left - 32, 8),
      Math.max(container.clientWidth - 36, 8),
    );
    const top = Math.max(imageRect.top - containerRect.top + 6, 8);

    setSelectedImageDeleteIcon({ visible: true, top, left, pos });
  };

  const updateSelectedImageDeleteIcon = (editorInstance: any) => {
    const selectedNode = editorInstance?.state?.selection?.node;
    if (selectedNode?.type?.name !== "image") {
      setSelectedImageDeleteIcon((prev) =>
        prev.visible ? { ...prev, visible: false, pos: null } : prev,
      );
      return;
    }

    const imageNode = editorInstance.view.nodeDOM(
      editorInstance.state.selection.from,
    ) as HTMLElement | null;

    if (imageNode instanceof HTMLElement) {
      showImageDeleteIcon(imageNode, editorInstance.state.selection.from);
    }
  };

  const handleEditorImageHover = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!editor) return;

    const target = event.target as HTMLElement;
    if (target.closest(".task-editor-image-delete-icon")) return;

    const imageNode = target.closest(".ProseMirror img") as HTMLElement | null;
    if (imageNode) {
      const pos = editor.view.posAtDOM(imageNode, 0);
      showImageDeleteIcon(imageNode, pos);
      return;
    }

    const selectedNode = (editor.state.selection as any).node;
    if (selectedNode?.type?.name !== "image") {
      setSelectedImageDeleteIcon((prev) =>
        prev.visible ? { ...prev, visible: false, pos: null } : prev,
      );
    }
  };

  const handleEditorImageLeave = () => {
    if (!editor) return;

    const selectedNode = (editor.state.selection as any).node;
    if (selectedNode?.type?.name !== "image") {
      setSelectedImageDeleteIcon((prev) =>
        prev.visible ? { ...prev, visible: false, pos: null } : prev,
      );
    }
  };

  // TipTap editor instance with custom image
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        heading: false, // disable internal so we add our own
        bulletList: false,
        orderedList: false,
      }),

      Heading.configure({
        levels: [1, 2, 3],
      }),

      BulletList.configure({
        keepMarks: true,
        keepAttributes: false,
      }),

      Underline,
      Link.configure({
        openOnClick: true,
        HTMLAttributes: { class: "text-blue-500 underline" },
      }),

      Image.extend({
        addAttributes() {
          return {
            src: { default: null },
            alt: { default: null },
            title: { default: null },
            width: {
              default: 300,
              renderHTML: (attributes: any) => ({
                width: attributes.width,
                style: `width: ${attributes.width}px; height: auto; max-width: 100%;`,
              }),
            },
            height: { default: "auto" },
          };
        },
      }).configure({
        inline: false,
        HTMLAttributes: {
          class: "rounded-md",
          style: "max-width: 100%; height: auto;",
        },
      }),

      TextAlign.configure({
        types: ["heading", "paragraph"],
      }),

      Placeholder.configure({
        placeholder: "Enter task description2...",
      }),
    ],
    content: "", // will be set later from fetched task data
    editable: true,
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      setDescValue(html);
      form.setFieldsValue({ taskDesc: html });
    },
    onSelectionUpdate: ({ editor }) => {
      updateSelectedImageDeleteIcon(editor);
    },
    editorProps: {
      handlePaste: (view, event) => {
        const items = Array.from(event.clipboardData?.items || []);
        let imageProcessed = false;

        for (const item of items) {
          if (item.type.startsWith("image/")) {
            event.preventDefault();
            const file = item.getAsFile();
            if (!file) continue;

            // Add to uploaded images for form submission
            setUploadedImages((prev) => [...prev, file]);

            // Convert to base64 and insert into editor with reduced size
            const reader = new FileReader();
            reader.onload = () => {
              const transaction = view.state.tr.insert(
                view.state.selection.from,
                view.state.schema.nodes.image.create({
                  src: reader.result,
                  alt: "Pasted image",
                  title: "Pasted image",
                  width: 300,
                }),
              );
              view.dispatch(transaction);
            };
            reader.readAsDataURL(file);
            imageProcessed = true;
            break;
          }
        }
        return imageProcessed;
      },
      handleDrop: (view, event, slice, moved) => {
        if (event.dataTransfer?.files) {
          const files = Array.from(event.dataTransfer.files);
          let imageProcessed = false;

          files.forEach((file) => {
            if (file.type.startsWith("image/")) {
              event.preventDefault();
              imageProcessed = true;

              // Add to uploaded images for form submission
              setUploadedImages((prev) => [...prev, file]);

              // Convert to base64 and insert into editor with reduced size
              const reader = new FileReader();
              reader.onload = () => {
                const coordinates = view.posAtCoords({
                  left: event.clientX,
                  top: event.clientY,
                });

                if (coordinates) {
                  const transaction = view.state.tr.insert(
                    coordinates.pos,
                    view.state.schema.nodes.image.create({
                      src: reader.result,
                      alt: file.name,
                      title: file.name,
                      width: 300,
                    }),
                  );
                  view.dispatch(transaction);
                }
              };
              reader.readAsDataURL(file);
            }
          });

          return imageProcessed;
        }
        return false;
      },
    },
  });

  // Add these toolbar functions after the editor configuration
  const setLink = () => {
    if (linkUrl) {
      editor?.chain().focus().setLink({ href: linkUrl }).run();
      setLinkUrl("");
      setShowLinkInput(false);
    }
  };

  const unsetLink = () => {
    editor?.chain().focus().unsetLink().run();
    setShowLinkInput(false);
  };

  const deleteSelectedImage = () => {
    if (!editor) return;

    const selectedNode = (editor.state.selection as any).node;
    if (selectedNode?.type?.name === "image") {
      editor.chain().focus().deleteSelection().run();
      setSelectedImageDeleteIcon({
        visible: false,
        top: 0,
        left: 0,
        pos: null,
      });
      return;
    }

    const imagePos = selectedImageDeleteIcon.pos;
    const imageRange =
      imagePos !== null
        ? [imagePos, imagePos - 1]
            .filter((pos) => pos >= 0)
            .map((pos) => ({ pos, node: editor.state.doc.nodeAt(pos) }))
            .find(({ node }) => node?.type.name === "image")
        : null;

    if (!imageRange?.node) {
      message.info("Click an image first, then delete it.");
      return;
    }

    editor
      .chain()
      .focus()
      .deleteRange({
        from: imageRange.pos,
        to: imageRange.pos + imageRange.node.nodeSize,
      })
      .run();
    setSelectedImageDeleteIcon({ visible: false, top: 0, left: 0, pos: null });
  };

  // Add the Toolbar component after the toolbar functions
  const Toolbar = () => {
    if (!editor) return null;

    return (
      <div className="border-b border-gray-200 p-2 flex flex-wrap items-center gap-1 bg-gray-50">
        {/* Text formatting */}
        <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
          <Button
            type={editor.isActive("bold") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleBold().run()}
            title="Bold"
          >
            <strong>B</strong>
          </Button>
          <Button
            type={editor.isActive("italic") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleItalic().run()}
            title="Italic"
          >
            <em>I</em>
          </Button>
          <Button
            type={editor.isActive("underline") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleUnderline().run()}
            title="Underline"
          >
            <u>U</u>
          </Button>
          <Button
            type={editor.isActive("strike") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleStrike().run()}
            title="Strikethrough"
          >
            <s>S</s>
          </Button>
        </div>

        {/* Headings */}
        <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
          <Button
            type={
              editor.isActive("heading", { level: 1 }) ? "primary" : "default"
            }
            size="small"
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 1 }).run()
            }
            title="Heading 1"
          >
            H1
          </Button>
          <Button
            type={
              editor.isActive("heading", { level: 2 }) ? "primary" : "default"
            }
            size="small"
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 2 }).run()
            }
            title="Heading 2"
          >
            H2
          </Button>
          <Button
            type={
              editor.isActive("heading", { level: 3 }) ? "primary" : "default"
            }
            size="small"
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 3 }).run()
            }
            title="Heading 3"
          >
            H3
          </Button>
          <Button
            type={editor.isActive("paragraph") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().setParagraph().run()}
            title="Paragraph"
          >
            P
          </Button>
        </div>

        {/* Lists */}
        <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
          <Button
            type={editor.isActive("bulletList") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleBulletList().run()}
            title="Bullet List"
          >
            • List
          </Button>
          <Button
            type={editor.isActive("orderedList") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleOrderedList().run()}
            title="Numbered List"
          >
            1. List
          </Button>
          <Button
            type={editor.isActive("blockquote") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleBlockquote().run()}
            title="Blockquote"
          >
            ❝
          </Button>
        </div>

        {/* Alignment */}
        <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
          <Button
            type={
              editor.isActive({ textAlign: "left" }) ? "primary" : "default"
            }
            size="small"
            onClick={() => editor.chain().focus().setTextAlign("left").run()}
            title="Align Left"
          >
            ⬅
          </Button>
          <Button
            type={
              editor.isActive({ textAlign: "center" }) ? "primary" : "default"
            }
            size="small"
            onClick={() => editor.chain().focus().setTextAlign("center").run()}
            title="Align Center"
          >
            ↔
          </Button>
          <Button
            type={
              editor.isActive({ textAlign: "right" }) ? "primary" : "default"
            }
            size="small"
            onClick={() => editor.chain().focus().setTextAlign("right").run()}
            title="Align Right"
          >
            ➡
          </Button>
        </div>

        {/* Links */}
        <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
          {showLinkInput ? (
            <div className="flex items-center gap-1">
              <Input
                size="small"
                placeholder="Enter URL"
                value={linkUrl}
                onChange={(e) => setLinkUrl(e.target.value)}
                style={{ width: 150 }}
              />
              <Button size="small" type="primary" onClick={setLink}>
                Add
              </Button>
              <Button size="small" onClick={unsetLink}>
                Remove
              </Button>
            </div>
          ) : (
            <Button
              type={editor.isActive("link") ? "primary" : "default"}
              size="small"
              onClick={() => setShowLinkInput(true)}
              title="Add Link"
            >
              🔗
            </Button>
          )}
        </div>

        {/* Media */}
        <div className="flex items-center gap-1">
          <Button
            size="small"
            onClick={addImage}
            title="Insert Image"
            icon={<UploadOutlined />}
          >
            Image
          </Button>
        </div>

        {/* Clear formatting */}
        <div className="flex items-center gap-1 border-l border-gray-300 pl-2">
          <Button
            size="small"
            onClick={() =>
              editor.chain().focus().clearNodes().unsetAllMarks().run()
            }
            title="Clear Formatting"
          >
            Clear
          </Button>
          <Button
            size="small"
            onClick={() => editor.chain().focus().undo().run()}
            title="Undo"
          >
            ↶
          </Button>
          <Button
            size="small"
            onClick={() => editor.chain().focus().redo().run()}
            title="Redo"
          >
            ↷
          </Button>
        </div>
      </div>
    );
  };

  const addImage = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.multiple = true;
    input.click();

    input.onchange = () => {
      const files = Array.from(input.files || []);
      const imageFiles = files.filter((file) => file.type.startsWith("image/"));

      // Add all images to uploaded images at once
      setUploadedImages((prev) => [...prev, ...imageFiles]);

      // Insert images one by one with reduced size
      imageFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          editor
            ?.chain()
            .focus()
            .setImage({
              src: reader.result as string,
              alt: file.name,
              title: file.name,
              width: 300,
            })
            .run();
        };
        reader.readAsDataURL(file);
      });
    };
  };

  const clearDescription = () => {
    editor?.commands.setContent("");
    setUploadedImages([]);
    setFileList([]);
    form.setFieldsValue({ taskDesc: "" });
  };

  const handleDeadlineDateChange = (date: dayjs.Dayjs | null) => {
    try {
      // Update form value immediately
      form.setFieldValue("deadlineDate", date);

      // Optional: Show feedback to user
      // if (date) {
      //   message.success(`Deadline updated to: ${date.format('DD-MM-YYYY HH:mm')}`, 2);
      // }

      // Auto-close the picker after a short delay
      setTimeout(() => {
        setDatePickerOpen(false);
      }, 300);
    } catch (error) {
      console.error("Error setting deadline date:", error);
    }
  };

  // Handle notification switch change
  const handleNotificationSwitch = (checked: boolean) => {
    setNotificationEnabled(checked);
    if (checked) {
      message.info("Notifications enabled for this task update");
    } else {
      message.info("Notifications disabled for this task update");
    }
  };

  useEffect(() => {
    const fetchBoards = async () => {
      const response = await getallBoard("", 1);
      setBoards(response.data);
    };
    fetchBoards();
  }, []);

  useEffect(() => {
    const fetchDevelopers = async () => {
      try {
        setLoading(true);
        const response: any = await getallDeveloperForTask("", "");
        if (response?.data) {
          setDevelopers(response.data);
        } else {
          setDevelopers([]);
        }
      } catch (error) {
        console.error("Error fetching developers:", error);
        message.error("Failed to load developers");
        setDevelopers([]);
      } finally {
        setLoading(false);
      }
    };

    const fetchReporters = async () => {
      try {
        const response: any = await getallReporterLoginUser("");
        if (response) {
          setReporters(response?.data);
        } else {
          setReporters([]);
        }
      } catch (error) {
        console.error("Error fetching reporters:", error);
        message.error("Failed to load reporters");
        setReporters([]);
      }
    };

    const fetchProjectNames = async () => {
      try {
        const response: any = await getProjectName();

        // 🧠 Get full user auth data from localStorage
        const authData = JSON.parse(localStorage.getItem("authData") || "{}");
        const user = authData?.user;
        const role = authData?.roleId;

        const userId = user?._id;
        const roleSlug = role?.slug?.toLowerCase(); // e.g., "team", "admin", etc.

        let filteredProjects = response.data;

        // ✅ Apply filter only for developers/team role
        if (roleSlug === "team" || roleSlug === "developers") {
          filteredProjects = response.data.filter(
            (project: any) =>
              Array.isArray(project.assignees) &&
              project.assignees.some(
                (assignee: any) =>
                  assignee === userId || assignee?._id === userId,
              ),
          );
        }

        setProjectName(filteredProjects);
      } catch (error) {
        console.error("Error fetching project names:", error);
        message.error("Failed to load projects");
        setProjectName([]);
      }
    };
    fetchProjectNames();

    fetchDevelopers();
    fetchReporters();
  }, []);

  const fetchTask = async () => {
    if (!taskId) return;
    setLoading(true);

    try {
      const data = await getTaskByID(taskId);
      console.log("sendNotifications from API:", data.sendNotifications);
      setTask(data);

      if (data) {
        form.setFieldsValue({
          userId: data.userId?._id,
          boardId: data.boardId,
          taskName: data.taskName,
          startDate: data.startDate ? dayjs(data.startDate) : null,
          deadlineDate: data.deadlineDate ? dayjs(data.deadlineDate) : null,
          status: data.status,
          priority: data.priority,
          assignees: data.assignees?.map((a: any) => a._id),
          reporterId: data.reporter?._id,
          isActive: true,
          taskDesc: data.taskDesc || "",
          subTasks:
            data.subTasks?.map((s: any) => ({
              subTaskName: s.subTaskName,
              subTaskDesc: s.subTaskDesc,
              status: s.status,
              assignees: s.assignees?.map((a: any) => a._id) || [],
              isActive: true,
            })) || [],
        });

        // ✅ Prepare editor content
        let editorContent = data.taskDesc || "";

        const photos = normalizeTaskPhotos(data.photo);

        if (photos.length > 0) {
          editorContent = removeTemporaryImagesFromHtml(editorContent);
          const existingPhotoNames = getTaskPhotoNamesFromHtml(editorContent);
          const missingPhotos = photos.filter(
            (img) => !existingPhotoNames.includes(img),
          );
          const imageHTML = missingPhotos
            .map(
              (img: any) =>
                `<p><img src="${getTaskPhotoUrl(img)}" width="300" /></p>`,
            )
            .join("");
          editorContent = `${imageHTML}${editorContent}`;
        }

        // ✅ Set TipTap editor content
        if (editor) {
          editor.commands.setContent(editorContent);
        }

        // ✅ Show image previews in Upload
        if (photos.length > 0) {
          setFileList(
            photos.map((img: string, index: number) => ({
              uid: `existing-${index}`,
              name: img.split("/").pop() || `photo-${index}`,
              status: "done",
              url: getTaskPhotoUrl(img),
            })),
          );
        } else {
          setFileList([]);
        }

        // Set notification switch based on task data
        // console.log("Task data notifications field:", data.notifications, "Type:", typeof data.notifications);
        setNotificationEnabled(
          data.sendNotifications === "true" || data.sendNotifications === true,
        );
      }
    } catch (error) {
      message.error("Failed to fetch task data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible && taskId && editor) {
      fetchTask();
    } else if (!visible) {
      form.resetFields();
      setDescValue("");
      setUploadedImages([]);
      setFileList([]);
      editor?.commands.setContent("");
      setDatePickerOpen(false);
      setNotificationEnabled(false); // Reset notification switch
    }
  }, [visible, taskId, editor]);

  const handleSubmit = async (values: any) => {
    try {
      setLoading(true);

      const formData = new FormData();

      // ✅ Append normal fields
      const simpleFields = [
        "userId",
        "boardId",
        "taskName",
        "status",
        "priority",
        "reporterId",
      ];
      simpleFields.forEach((field) => {
        if (values[field] !== undefined && values[field] !== null) {
          formData.append(field, values[field]);
        }
      });

      const htmlContent = editor?.getHTML() || "";
      const hasText = editor?.getText().trim().length || 0;
      const hasImages = /<img\b/i.test(htmlContent);

      if (!hasText && !hasImages) {
        message.error("Please enter a task description or upload an image");
        setLoading(false);
        return;
      }

      // ✅ Append the HTML content to formData
      formData.append("taskDesc", htmlContent);

      // ✅ Add notification preference to form data (must match Add.tsx)
      formData.append("sendNotifications", String(notificationEnabled));

      const remainingPhotos = getTaskPhotoNamesFromHtml(htmlContent);

      formData.append("remainingPhotos", JSON.stringify(remainingPhotos));

      uploadedImages.forEach((file) => {
        formData.append("photo", file);
      });

      if (remainingPhotos.length === 0 && uploadedImages.length === 0) {
        formData.append("removePhoto", "true");
      }

      // ✅ Handle Dates
      if (values.startDate)
        formData.append("startDate", values.startDate.format());
      if (values.deadlineDate)
        formData.append("deadlineDate", values.deadlineDate.format());

      // ✅ Handle Assignees
      (values.assignees || []).forEach((id: string) => {
        formData.append("assignees[]", id);
      });

      // ✅ Handle SubTasks
      (values.subTasks || []).forEach((subtask: any, index: number) => {
        formData.append(`subTasks[${index}][subTaskName]`, subtask.subTaskName);
        formData.append(`subTasks[${index}][subTaskDesc]`, subtask.subTaskDesc);
        formData.append(`subTasks[${index}][status]`, subtask.status);
        (subtask.assignees || []).forEach((a: string, i: number) => {
          formData.append(`subTasks[${index}][assignees][${i}]`, a);
        });
        formData.append(`subTasks[${index}][isActive]`, "true");
      });

      // ✅ API call
      const response = await updateTask(taskId as string, formData);

      if (response && (response.status === 200 || response.status === 201)) {
        const updatedTask = response.data?.data || response.data;

        // Show different success message based on notification preference
        if (notificationEnabled) {
          message.success(
            "Task updated successfully! Notifications will be sent.",
          );
        } else {
          message.success(
            "Task updated successfully! (Notifications disabled)",
          );
        }

        dispatch(
          updateTaskLocal({ taskId: taskId as string, updates: updatedTask }),
        );

        setFileList([]);
        if (onSuccess) onSuccess();
      } else {
        message.error(response?.data?.message || "Failed to update task");
      }
    } catch (error: any) {
      message.error(
        "Task update failed: " +
          (error.response?.data?.message || "Server error"),
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!editor) return;

    const handleDrop = (event: DragEvent) => {
      event.preventDefault();

      const files = Array.from(event.dataTransfer?.files || []);
      files.forEach((file) => {
        if (!file.type.startsWith("image/")) return;

        const reader = new FileReader();
        reader.onload = () => {
          //@ts-ignore
          editor
            .chain()
            .focus()
            .setImage({ src: reader.result as string, width: 200 })
            .run();
          setUploadedImages((prev) => [...prev, file]);
          setFileList((prev) => [
            ...prev,
            {
              uid: `new-${Date.now()}`,
              name: file.name,
              status: "done",
              url: URL.createObjectURL(file),
            } as UploadFile,
          ]);
        };
        reader.readAsDataURL(file);
      });
    };

    const handlePaste = (event: ClipboardEvent) => {
      const items = Array.from(event.clipboardData?.items || []);
      items.forEach((item) => {
        if (item.type.indexOf("image") === -1) return;
        const file = item.getAsFile();
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
          //@ts-ignore
          editor
            .chain()
            .focus()
            .setImage({ src: reader.result as string, width: 200 })
            .run();
          setUploadedImages((prev) => [...prev, file]);
          setFileList((prev) => [
            ...prev,
            {
              uid: `new-${Date.now()}`,
              name: file.name,
              status: "done",
              url: URL.createObjectURL(file),
            },
          ]);
        };
        reader.readAsDataURL(file);
      });
    };

    const editorElement = editor.view.dom;
    editorElement.addEventListener("drop", handleDrop);
    editorElement.addEventListener("paste", handlePaste);

    return () => {
      editorElement.removeEventListener("drop", handleDrop);
      editorElement.removeEventListener("paste", handlePaste);
    };
  }, [editor]);

  const handleFormChange = (_: any, allValues: any) => {
    const { startDate, deadlineDate } = allValues;
    if (startDate && deadlineDate) {
      setIsStatusDisabled(false);
    } else {
      setIsStatusDisabled(true);
    }
  };

  const handleDeletePhoto = async () => {
    try {
      setLoading(true);
      const response = await deleteTaskPhoto(taskId as string);
      if (response && (response.status === 200 || response.status === 201)) {
        message.success("Photo deleted successfully!");
        setFileList([]);
        setTask((prev: any) => ({ ...prev, photo: null }));
        // Clear the image from the editor
        editor?.commands.setContent(editor.getText().trim());
      } else {
        message.error(response?.data?.message || "Failed to delete photo");
      }
    } catch (error: any) {
      message.error(
        "Photo deletion failed: " +
          (error.response?.data?.message || "Server error"),
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={700}
      centered
      className="custom-modal"
      bodyStyle={{
        overflowY: "auto",
        fontFamily: "inter, sans-serif",
      }}
      styles={{
        header: {
          padding: "12px",
          position: "sticky",
          top: 0,
          backgroundColor: "#f1f5ffff",
        },
        content: {
          padding: 0,
          overflow: "hidden",
        },
      }}
      title={
        <div
          style={{
            color: "#4b5563",
            fontFamily: "inter, sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Edit Task
        </div>
      }
    >
      <Form
        onFinish={handleSubmit}
        form={form}
        layout="horizontal"
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 19 }}
        colon={false}
        onValuesChange={handleFormChange}
      >
        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              Board<span className="text-red-500">*</span>
            </span>
          }
          required={false}
          name="boardId"
          rules={[{ required: true, message: "Please select a board" }]}
        >
          <Select placeholder="Select Board" disabled={!isAdmin}>
            {boards.map((board: any) => (
              <Option key={board._id} value={board._id}>
                {board.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              Task Name<span className="text-red-500">*</span>
            </span>
          }
          required={false}
          name="taskName"
          rules={[{ required: true, message: "Please enter task name" }]}
        >
          <Select placeholder="Select Project" showSearch>
            {ProjectName.map((p: any) => (
              <Option key={p._id} value={p.projectName}>
                {p.projectName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              Description<span className="text-red-500">*</span>
            </span>
          }
          required={false}
          rules={[{ required: true, message: "Please enter description" }]}
        >
          <div className="border rounded bg-white">
            <Toolbar />
            <div
              ref={editorContainerRef}
              className="p-3 min-h-[150px]"
              style={{ position: "relative" }}
              onMouseMove={handleEditorImageHover}
              onMouseLeave={handleEditorImageLeave}
            >
              {selectedImageDeleteIcon.visible && (
                <button
                  type="button"
                  className="task-editor-image-delete-icon"
                  style={{
                    position: "absolute",
                    top: selectedImageDeleteIcon.top,
                    left: selectedImageDeleteIcon.left,
                    zIndex: 50,
                    background: "rgba(239, 68, 68, 0.9)",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    width: "24px",
                    height: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    fontSize: "12px",
                    padding: 0,
                  }}
                  onMouseDown={(event) => event.preventDefault()}
                  onClick={deleteSelectedImage}
                  aria-label="Delete selected image"
                  title="Delete selected image"
                >
                  <DeleteOutlined />
                </button>
              )}
              <EditorContent
                editor={editor}
                className="min-h-[100px] outline-none"
              />
            </div>
          </div>
        </Form.Item>

        <Form.Item name="taskDesc" hidden>
          <Input type="hidden" />
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              Deadline Date<span className="text-red-500">*</span>
            </span>
          }
          required={false}
          name="deadlineDate"
          rules={[{ required: true, message: "Please select deadline" }]}
        >
          <DatePicker
            showTime
            format="DD-MM-YYYY HH:mm"
            className="w-full"
            open={datePickerOpen}
            onOpenChange={(open) => {
              setDatePickerOpen(open);
              // When closing without selection, ensure we have the current value
              if (!open) {
                const currentValue = form.getFieldValue("deadlineDate");
                if (currentValue) {
                  handleDeadlineDateChange(currentValue);
                }
              }
            }}
            onChange={(date) => {
              // Auto-save when date changes (including time changes)
              handleDeadlineDateChange(date);
            }}
            //@ts-ignore
            onSelect={(date) => {
              // Immediate save when selecting from calendar
              handleDeadlineDateChange(date);
            }}
            onOk={() => {
              // Empty function - we don't need OK button
            }}
            // Remove the need for confirmation
            needConfirm={false}
            disabledDate={(current) => {
              return current && current < dayjs().startOf("day");
            }}
            showNow={true}
            // Optional: Auto-close when time is selected
            onPanelChange={(value, mode) => {
              if (mode === "time") {
                // When switching to time panel, you might want different behavior
              }
            }}
          />
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              Priority<span className="text-red-500">*</span>
            </span>
          }
          required={false}
          name="priority"
          rules={[{ required: true, message: "Please select priority" }]}
        >
          <Select placeholder="Select Priority">
            <Option value="Low">Low</Option>
            <Option value="Medium">Medium</Option>
            <Option value="High">High</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              Assignees<span className="text-red-500">*</span>
            </span>
          }
          required={false}
          name="assignees"
          rules={[
            { required: true, message: "Please select at least one assignee" },
          ]}
        >
          <Select
            mode="multiple"
            placeholder="Select Assignees"
            filterOption={(input, option) =>
              (option?.children ?? "")
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {developers.map((dev) => (
              <Option key={dev._id} value={dev._id}>
                {dev.username}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              Reporter
            </span>
          }
          required={false}
          name="reporterId"
        >
          <Select placeholder="Select Reporter">
            {reporters.map((r) => (
              <Option key={r._id} value={r._id}>
                {r.reporterName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              SubTasks
            </span>
          }
          required={false}
          wrapperCol={{ span: 18 }}
        >
          {/* Row container for Add Subtask button and Notification switch */}
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-4">
              <Button
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() => {
                  const currentSubtasks = form.getFieldValue("subTasks") || [];
                  form.setFieldsValue({
                    subTasks: [...currentSubtasks, {}],
                  });
                }}
              >
                Add Subtask
              </Button>
            </div>

            {/* Notification Switch */}
            <div className="flex items-center gap-2">
              <span className="text-gray-600">Notifications</span>
              <Switch
                onChange={handleNotificationSwitch}
                checkedChildren="Enabled"
                unCheckedChildren="Disabled"
                defaultChecked={false}
                checked={notificationEnabled}
              />
            </div>
          </div>

          <Form.List name="subTasks">
            {(fields, { add, remove }) => (
              <div>
                {fields.map(({ key, name, ...restField }) => (
                  <div
                    key={key}
                    className="border rounded p-3 mb-3 bg-white shadow-sm"
                  >
                    <div className="grid grid-cols-2 gap-3">
                      <Form.Item
                        {...restField}
                        name={[name, "subTaskName"]}
                        rules={[
                          { required: true, message: "Subtask name required" },
                        ]}
                      >
                        <Input
                          placeholder="Subtask name"
                          className="Allinput"
                        />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, "subTaskDesc"]}>
                        <Input placeholder="Description" className="Allinput" />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, "status"]}
                        initialValue="Pending"
                      >
                        <Select placeholder="Status">
                          <Option value="Pending">Pending</Option>
                          <Option value="In Progress">In Progress</Option>
                          <Option value="Completed">Completed</Option>
                        </Select>
                      </Form.Item>
                      <Form.Item {...restField} name={[name, "assignees"]}>
                        <Select mode="multiple" placeholder="Assignees">
                          {developers.map((dev) => (
                            <Option key={dev._id} value={dev._id}>
                              {dev.username}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                    <Button danger type="text" onClick={() => remove(name)}>
                      Remove
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </Form.List>
        </Form.Item>

        <div className="flex justify-end gap-3 pr-5">
          <button
            type="button"
            className="allcanclebutton"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button className="allsubmitebutton" type="submit">
            {isLoading ? "Updating..." : "Update"}
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default EditTaskModal;
